import { useEffect, useState } from "react";
import { createTeeshotAxiosInstance } from "src/http";
import { District } from "src/types";
import useAlert from "./useAlert";

function useGroupLocation() {
  const [groupLocations, setGroupLocations] = useState<District[]>();

  const alert = useAlert();
  useEffect(() => {
    (async () => {
      try {
        const res = await createTeeshotAxiosInstance().get("/common/district");
        setGroupLocations(
          (() => {
            const allCountryIdx = res.data.data.findIndex((d: any) => d.cd === 40);
            const [allCountry] = res.data.data.splice(allCountryIdx, 1) || [];
            if (allCountry) {
              return [allCountry, ...(res?.data?.data ?? [])];
            }
            return res.data.data;
          })() as District[]
        );
        if (res.data.success === false) {
          throw new Error();
        }
      } catch (e) {
        alert({ content: "지역정보 에러" });
      }
    })();
  }, []);

  return groupLocations;
}

export default useGroupLocation;
